import React from "react";
import { LoaderCircle } from "lucide-react";

import WSMLogo from "../components/WSMLogo";

const Loading = () => {
  return (
    <main aria-busy="true" aria-label="Loading Worksite Manager" className="wsm-app-loading" role="status">
      <div aria-hidden="true" className="wsm-app-loading__card">
        <span className="wsm-app-loading__mark"><WSMLogo /></span>
        <p className="wsm-app-loading__suite">RailHub</p>
        <h1>Worksite Manager</h1>
        <div className="wsm-app-loading__status">
          <LoaderCircle />
          <span>Loading your workspace…</span>
        </div>
      </div>
    </main>
  );
};

export default Loading;
